// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/cost-sharing-and-compensation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/cost-sharing-and-compensation/cost-sharing-and-compensation.js';

mount([g0]);
